import React from "react";
import { cn } from "@/lib/utils";
import { useAppStore } from "@/hooks/useAppStore";

interface TypingIndicatorProps {
  isVisible: boolean;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  isVisible,
}) => {
  const isPresentationMode = useAppStore((state) => state.isPresentationMode);
  return (
    <div
      className={cn(
        "absolute left-1/2 -translate-x-1/2 p-2 bg-neutral-800/80 rounded-full transition-opacity duration-300 ease-in-out",
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none",
        isPresentationMode ? "bottom-30" : "bottom-40"
      )}
      aria-hidden={!isVisible} // Accessibility
    >
      <div className="flex items-center gap-1 px-2">
        <div className="h-1.5 w-1.5 animate-blink rounded-full bg-white/60 [animation-delay:0s]"></div>
        <div className="h-1.5 w-1.5 animate-blink rounded-full bg-white/60 [animation-delay:0.2s]"></div>
        <div className="h-1.5 w-1.5 animate-blink rounded-full bg-white/60 [animation-delay:0.4s]"></div>
      </div>
    </div>
  );
};
